export default __webpack_public_path__ + "static/media/Koos Knee Injury & Osteoarthritis Questionnaire.0d0b638b.pdf";